import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidePage from "../pages/article/guide/page";
import KakobuyPage from "../pages/article/kakobuy/page";
import CSSBuyPage from "../pages/article/cssbuy/page";
import SuperbuyPage from "../pages/article/superbuy/page";
import OopbuyPage from "../pages/article/oopbuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <GuidePage />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <KakobuyPage />,
  },
  {
    path: "/cssbuy-spreadsheet-guide",
    element: <CSSBuyPage />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <SuperbuyPage />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <OopbuyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;